import OnboardModalFooter from "./OnboardModalFooter";

export default OnboardModalFooter;
